import React, { useState } from 'react'
import './Courses.scss';
import { PiNote, PiVideoLight } from 'react-icons/pi';
import { GoPlus } from 'react-icons/go';
import { IoFilter, IoTimeOutline } from 'react-icons/io5';
import { FaStar } from 'react-icons/fa';
import { FaCircleArrowUp } from "react-icons/fa6";
import { PiUsersThreeBold } from "react-icons/pi";
import { IoIosArrowDown } from "react-icons/io";
import { TfiCup } from "react-icons/tfi";
import { TbFileDownload } from "react-icons/tb";
import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';



const coursesData = [
  {
    name: "Mastering Focus & Productivity",
    description: "Learn science-backed techniques to eliminate distractions, manage your time better, and boost deep work sessions.",
    duration: 7,
    rating: 4.8,
    reviews: 8.4,
    users: 500,
    image: "/images/course_img.jpg",
    courseContent: [
      {
        title: "Introduction to Focus & Productivity",
        type: "Video",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Breaking Procrastination Loops",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Deep Work Techniques",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          {
            type: <PiVideoLight />,
            title: "Overview of common distractions & productivity myths",
            duration: "10 Min"
          },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Introduction to Focus & Productivity",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
    ]
  },
  {
    name: "Emotional Intelligence at Work",
    description: "Understand and apply emotional intelligence to build better relationships and manage workplace stress.",
    duration: 5,
    rating: 4.7,
    reviews: 6.1,
    users: 550,
    image: "/images/course_img.jpg",
    courseContent: [
      {
        title: "Introduction to Focus & Productivity",
        type: "Video",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Breaking Procrastination Loops",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Deep Work Techniques",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          {
            type: <PiVideoLight />,
            title: "Overview of common distractions & productivity myths",
            duration: "10 Min"
          },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Introduction to Focus & Productivity",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
    ]
  },
  {
    name: "Effective Communication Skills",
    description: "Master verbal and non-verbal communication strategies to boost your confidence and influence.",
    duration: 6,
    rating: 4.9,
    reviews: 10.2,
    users: 600,
    image: "/images/course_img.jpg",
    courseContent: [
      {
        title: "Introduction to Focus & Productivity",
        type: "Video",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Breaking Procrastination Loops",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Deep Work Techniques",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          {
            type: <PiVideoLight />,
            title: "Overview of common distractions & productivity myths",
            duration: "10 Min"
          },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Introduction to Focus & Productivity",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
    ]
  },
  {
    name: "Time Management Essentials",
    description: "Learn proven frameworks to prioritize tasks, set achievable goals, and increase daily productivity.",
    duration: 4,
    rating: 4.6,
    reviews: 7.3,
    users: 650,
    image: "/images/course_img.jpg",
    courseContent: [
      {
        title: "Introduction to Focus & Productivity",
        type: "Video",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Breaking Procrastination Loops",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Deep Work Techniques",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          {
            type: <PiVideoLight />,
            title: "Overview of common distractions & productivity myths",
            duration: "10 Min"
          },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Introduction to Focus & Productivity",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
    ]
  },
  {
    name: "Mindfulness for Everyday Life",
    description: "Develop mindfulness habits to reduce stress, improve focus, and live in the present moment.",
    duration: 3.5,
    rating: 4.8,
    reviews: 9.7,
    users: 700,
    image: "/images/course_img.jpg",
    courseContent: [
      {
        title: "Introduction to Focus & Productivity",
        type: "Video",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Breaking Procrastination Loops",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Deep Work Techniques",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          {
            type: <PiVideoLight />,
            title: "Overview of common distractions & productivity myths",
            duration: "10 Min"
          },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Introduction to Focus & Productivity",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
    ]
  },
  {

    name: "Leadership & Influence",
    description: "Build strong leadership qualities to inspire teams, drive change, and lead with integrity.",
    duration: 8,
    rating: 4.7,
    reviews: 5.4,
    users: 750,
    image: "/images/course_img.jpg",
    courseContent: [
      {
        title: "Introduction to Focus & Productivity",
        type: "Video",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Breaking Procrastination Loops",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Deep Work Techniques",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          {
            type: <PiVideoLight />,
            title: "Overview of common distractions & productivity myths",
            duration: "10 Min"
          },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
      {
        title: "Introduction to Focus & Productivity",
        type: "3 Lectures",
        duration: "10 Min",
        lectures: [
          { type: <PiVideoLight />, title: "Overview of common distractions & productivity myths", duration: "10 Min" },
          { type: <PiVideoLight />, title: "How your brain processes focus, multitasking, and flow", duration: "10 Min" },
          { type: <PiNote />, title: "Why we delay tasks & simple hacks to get started", duration: "10 Min" },
        ],
      },
    ]
  },
];

interface Lecture {
  type: ReactNode;
  title: string;
  duration: string;
}

interface Section {
  title: string;
  type: string;
  duration: string;
  lectures: Lecture[];
}

interface Course {
  name: string;
  description: string;
  image: string;
  duration: number;
  rating: number;
  reviews: number;
  users: number;
  courseContent: Section[];
}


function Courses() {

  const navigate = useNavigate();


  const [openSections, setOpenSections] = useState<number[]>([]);
  const [selectedCourse, setSelectedCourse] = useState<Course | null>(null);

  const toggleSection = (idx: number) => {
    setOpenSections((prev) =>
      prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
    )
  };
  return (
    <div className="courses_content">

      {!selectedCourse && (
        <div className="courses_information">
          <div className="courses_header">
            <div className="courses_header_left">
              <p className="courses_title">Courses</p>
              <p className="courses_subtitle">
                Learn, reflect, and grow — at your own pace.
              </p>
            </div>

            <div className="courses_header_right">
              <select className="courses_select">
                <option value="">Popular</option>
                <option value="">Newest</option>
                <option value="">Trending</option>
              </select>

              <button className="courses_filter">
                <IoFilter />
                <span>Filters</span>
              </button>
            </div>
          </div>

          <div className="course_details">
            {coursesData.map((course: Course, index: number) => (
              <div
                className="course_card"
                key={index}
                onClick={() => {
                  setSelectedCourse(course);
                  navigate("/courses", { state: { courseTitle: course.name } })
                }}
              >
                <img
                  src={course.image}
                  alt={course.name}
                  className="course_image"
                />

                <div className="course_info">
                  <p className="course_name">{course.name}</p>
                  <p className="course_description">{course.description}</p>

                  <div className="course_meta">
                    <div className="course_duration">
                      <IoTimeOutline />
                      <p>{course.duration}h</p>
                    </div>
                    <div className="course_rating">
                      <FaStar />
                      <p>
                        {course.rating} <span>({course.reviews}K)</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {selectedCourse && (
        <div className="course_detail_page">
          <div className="course_detail_wrapper">
            <div className="course_main">
              <div className="course_header">
                <div className="course_title_section">
                  <p className="course_name">{selectedCourse.name}</p>
                  <p className="course_description">
                    {selectedCourse.description}
                  </p>
                  <div className="course_meta">
                    <div className="course_duration">
                      <IoTimeOutline />
                      <p>{selectedCourse.duration} hours</p>
                    </div>
                    <div className="course_rating">
                      <FaStar />
                      <p>
                        {selectedCourse.rating}{" "}
                        <span>({selectedCourse.reviews}K)</span>
                      </p>
                    </div>
                    <div className="course_users">
                      <PiUsersThreeBold />
                      <p>{selectedCourse.users}</p>
                    </div>
                  </div>
                </div>
                <button className="start_course_btn">Start course</button>
              </div>

              <div className="course_content">
                {selectedCourse.courseContent.map((section: Section, idx: number) => (
                  <div key={idx} className="course_section">
                    <div className="course_section_heading" onClick={() => toggleSection(idx)}>
                      <div className="section_title">
                        <IoIosArrowDown
                          className={`arrow ${openSections.includes(idx) ? "rotate" : ""}`}
                        />
                        <p>{section.title}</p>
                      </div>
                      <div className="section_meta">
                        <p>{section.type}</p>
                        <p>|</p>
                        <p>{section.duration}</p>
                      </div>
                    </div>

                    {openSections.includes(idx) && (
                      <div className="course_section_body">
                        {section.lectures.map((lecture: Lecture, lidx: number) => (
                          <div key={lidx} className="lecture">
                            <div className="lec_details">
                              <p className="lec_icon">{lecture.type}</p>
                              <p className="lec_title">{lecture.title}</p>
                            </div>
                            <p className="lec_duration">{lecture.duration}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}

              </div>
            </div>

            <div className="course_sidebar">
              <img
                src={selectedCourse.image}
                alt="Course"
                className="sidebar_image"
              />
              <p className="sidebar_course_name">{selectedCourse.name}</p>
              <p className="sidebar_course_description">
                {selectedCourse.description}
              </p>
              <div className="sidebar_progress">
                <div className="progress_bar">
                  <div
                    className="progress_fill"
                    style={{ width: "10%" }}
                  ></div>
                </div>
                <p>10% complete</p>
              </div>

              <button className="start_course_btn">Start course</button>

              <p className="sidebar_section_title">This course includes:</p>
              <div className="course_features">
                <div className="feature">
                  <PiVideoLight />
                  <p>2.5 hours video</p>
                </div>
                <div className="feature">
                  <PiNote />
                  <p>2 notes</p>
                </div>
                <div className="feature">
                  <TbFileDownload />
                  <p>2 downloadable resources</p>
                </div>
                <div className="feature">
                  <TfiCup />
                  <p>Certification on completion</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="input_container">
        <div className="input_box">
          <GoPlus className="add_icon" />
          <input type="text" className="text_input" placeholder="Ask anything" />
          <FaCircleArrowUp className="send_icon" />
        </div>
      </div>

    </div>
  )
}

export default Courses